import { render, staticRenderFns } from "./MaterialLibrary.vue?vue&type=template&id=4b3cfa02&scoped=true&"
import script from "./MaterialLibrary.vue?vue&type=script&lang=js&"
export * from "./MaterialLibrary.vue?vue&type=script&lang=js&"
import style0 from "./MaterialLibrary.vue?vue&type=style&index=0&id=4b3cfa02&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b3cfa02",
  null
  
)

export default component.exports